<template>
  <div>
<!--    待付款批量付款 batchPay-->
<!--    待付款导出 export2-->
<!--    待付款采购付款 buyPay-->
<!--    待付款确认付款 okPay-->
<!--    批量支付 batchSubmit-->
<!--    批量查询  batchGetInfo-->
    <div>
      <el-form @submit.native.prevent inline label-width="100px">
<!--        <el-form-item label="订单号:">-->
<!--          <el-input v-model="searchData.ChildOrderNo" placeholder="子订单号"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="营客通订单号">
          <el-input v-model="searchData.ChildOrderNo" placeholder="营客通订单号"></el-input>
        </el-form-item>
        <el-form-item label="商品名称:">
          <el-input v-model="searchData.SkuName" placeholder="请输入商品名称"></el-input>
        </el-form-item>
        <el-form-item label="分销账号:">
          <el-input v-model="searchData.ChannelBusiness" placeholder="请输入分销账号"></el-input>
        </el-form-item>
        <el-form-item label="下单用户:">
          <el-input v-model="searchData.DistributorUserName" placeholder="下单用户"></el-input>
        </el-form-item>
<!--        <el-form-item label="订单状态">-->
<!--          <el-select v-model="searchData.Status" placeholder="请选择">-->
<!--            <el-option-->
<!--                v-for="item in options"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item label="供应商选择">
          <el-select @change="getOneData" style="margin-left:10px;margin-bottom:10px;" clearable
                     v-model="searchData.ResellerId" placeholder="请选择供应商">
            <el-option
                v-for="item in supplierList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-col :span="6">-->
        <!--          <el-form-item label="供应商" prop="SupplierId">-->
        <!--            <el-select v-model="searchData.SupplierId" filterable remote placeholder="请选择 / 可搜索"-->
        <!--                       :remote-method="querySupplier" style="width:100%">-->
        <!--              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">-->
        <!--              </el-option>-->
        <!--            </el-select>-->
        <!--          </el-form-item>-->
        <!--        </el-col>-->
<!--        <el-form-item label="支付时间：">-->
<!--          <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"-->
<!--                          style="width:100%">-->
<!--          </el-date-picker>-->
<!--        </el-form-item>-->
        <!--        <el-form-item label="采购单号:">-->
        <!--          <el-input v-model="searchData.orderPurchaseNo" placeholder="子订单号"></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <div style="display: flex;">
            <el-button type="primary" @click="searchFun">查询</el-button>
            <el-button @click="resetFun">重置</el-button>
            <!--          <toolbar style="margin-left:10px ;" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>-->
          </div>
        </el-form-item>
      </el-form>
      <div style="margin:10px;">
        <el-button v-if="isBatchPayShow" type="primary" @click="batchPay">批量付款</el-button>
        <el-button v-if="isExportShow" type="primary" @click="export2">导出</el-button>
<!--        <el-button v-if="isBuyShow" type="primary" @click="buyPay">采购付款</el-button>-->
      </div>
      <el-table @selection-change="selectCurrentRow" :data="tableList" highlight-current-row element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                style="width: 100%" border>
        <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
        <el-table-column prop="distributorUserName" label="分销账号" width="300" align="center">
        </el-table-column>
        <el-table-column prop="childOrderNo" label="副订单号" width="300" align="center">
        </el-table-column>
        <el-table-column label="商品名称" prop="skuName" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span v-if="Array.isArray(scope.row.orderPurchases) && scope.row.orderPurchases.length > 0">{{-->
          <!--              scope.row.orderPurchases[0].orderPurchaseNo-->
          <!--            }}</span>-->

          <!--          &lt;!&ndash;            {{ scope.row.orderPurchases[0]?.orderPurchaseNo }}&ndash;&gt;-->

          <!--        </template>-->
        </el-table-column>
        <el-table-column prop="modelCode" label="型号" align="center" min-width="200"></el-table-column>
        <el-table-column prop="skuSpecs" label="规格" width="200" align="center"></el-table-column>
        <el-table-column prop="skuNumber" label="购买数量" width="200" align="center"></el-table-column>
        <el-table-column label="分销价格" prop="skuPrice" width="250" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          <span style="display: inline-block;margin-right:10px;"> {{-->
          <!--              scope.row.orderItems &&-->
          <!--              scope.row.orderItems[0] && scope.row.orderItems[0].productSkuName-->
          <!--            }}</span>-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column label="采购价格" prop="purchasePrice" align="center" width="120">

        </el-table-column>
        <el-table-column label="采购合计" prop="purchaseAmount"  align="center" width="120">
        </el-table-column>
        <el-table-column label="收货人信息" width="150" align="center">
                  <template slot-scope="scope">
                    {{scope.row.receiverName}}
                    {{scope.row.receiverPhone}}
                    {{scope.row.receiverAddress}}
                  </template>
        </el-table-column>
        <el-table-column label="关联订单号" prop="associatedChildOrderNo" width="150" align="center">
          <!--        <template slot-scope="scope">-->
          <!--          {{-->
          <!--            scope.row.orderPurchases && scope.row.orderPurchases[0] && scope.row.orderPurchases[0].productSupplierName-->
          <!--          }}-->
          <!--        </template>-->
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200" align="center">
          <template slot-scope="scoped">
            <el-button v-if="isBuyShow" type="primary" @click="buyPay(scoped.row)" size="medium">采购付款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                     @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]"></el-pagination>
    </div>
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @close = closePurchaseDialog
        v-if="isBuyDialogShow"
        title="采购付款"
        :visible.sync="isBuyDialogShow"
        width="45%">
     <div>
       <el-card class="box-card">
         <div slot="header" class="clearfix">
           <span>付款商家分销账号</span>
<!--           <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
           <div style="margin:15px;">
             <el-row style="margin:15px;">
               <el-col :span="14">ID:&nbsp;&nbsp;{{ purchasePayData.distributorId }}</el-col>
               <el-col :span="9">余额:&nbsp;&nbsp;{{ purchasePayData.bonusAccountAmount}}</el-col>
             </el-row>
             <el-row style="margin:15px;color: #409EFF">
               <el-col :span="24">登录账号:&nbsp;&nbsp;<el-input :disabled="true" style="width: 200px;" size="mini" v-model="purchasePayData.distributorUserName" placeholder="请输入内容"></el-input></el-col>
             </el-row>
             <el-row style="margin:15px;color: #409EFF">
               <el-col :span="24">账号名称:&nbsp;&nbsp;<el-input style="width: 200px;" :disabled="true" size="mini" v-model="purchasePayData.distributorCompanyName" placeholder="请输入内容"></el-input></el-col>
             </el-row>
           </div>
         </div>
       </el-card>
       <el-row style="margin-top:20px;font-weight: bold;">
         <el-col :span="12">
           付款金额合计:&nbsp;&nbsp;{{ purchasePayData.orderAmount }}
         </el-col>
       </el-row>
       <el-row style="margin-top:20px;font-weight: bold;">
         <el-col :span="12">支付方式: &nbsp;&nbsp;<el-button type="success" size="mini" @click="balancePay">余额账户</el-button></el-col>
       </el-row>
     </div>
      <span slot="footer" class="dialog-footer">
<!--    <el-button @click="isBuyDialogShow = false">取 消</el-button>-->
<!--    <el-button type="primary" @click="isBuyDialogShow = false">确 定</el-button>-->
  </span>
    </el-dialog>
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @close = closeBatchPurchaseDialog
        v-if="isBatchBuyDialogShow"
        title="批量采购付款"
        :visible.sync="isBatchBuyDialogShow"
        width="45%">
      <div>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>付款商家分销账号</span>
            <!--           <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->
            <div style="margin:15px;">
              <el-row style="margin:15px;">
                <el-col :span="14">ID:&nbsp;&nbsp;{{ purchasePayData1.distributorId }}</el-col>
                <el-col :span="9">余额:&nbsp;&nbsp;{{ purchasePayData1.bonusAccountAmount}}</el-col>
              </el-row>
              <el-row style="margin:15px;color: #409EFF">
                <el-col :span="24">登录账号:&nbsp;&nbsp;<el-input :disabled="true" style="width: 200px;" size="mini" v-model="purchasePayData1.distributorUserName" placeholder="请输入内容"></el-input></el-col>
              </el-row>
              <el-row style="margin:15px;color: #409EFF">
                <el-col :span="24">账号名称:&nbsp;&nbsp;<el-input :disabled="true" style="width: 200px;" size="mini" v-model="purchasePayData1.distributorCompanyName" placeholder="请输入内容"></el-input></el-col>
              </el-row>
            </div>
          </div>
        </el-card>
        <el-row style="margin-top:20px;font-weight: bold;">
          <el-col :span="12">
            付款金额合计:&nbsp;&nbsp;{{ purchasePayData1.orderAmount }}
          </el-col>
        </el-row>
        <el-row style="margin-top:20px;font-weight: bold;">
          <el-col :span="12">支付方式: &nbsp;&nbsp;<el-button type="success" size="mini" @click="balanceBatchPay">余额账户</el-button></el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
<!--    <el-button @click="isBuyDialogShow = false">取 消</el-button>-->
        <!--    <el-button type="primary" @click="isBuyDialogShow = false">确 定</el-button>-->
  </span>
    </el-dialog>
    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @close="closePwdDialog"
        v-if="pwdDialog"
        title="输入密码"
        :visible.sync="pwdDialog"
        width="30%">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="密码">
          <el-input v-model="pwd" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitPwd">保存</el-button>
        </el-form-item>
      </el-form>
      <!--    <span slot="footer" class="dialog-footer">-->
      <!--    <el-button @click="singlePriceDialog = false">取 消</el-button>-->
      <!--    <el-button type="primary" @click="singlePriceDialog = false">确 定</el-button>-->
      <!--  </span>-->
    </el-dialog>

    <el-dialog
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @close="closePwdDialog1"
        v-if="pwdDialog1"
        title="输入密码"
        :visible.sync="pwdDialog1"
        width="30%">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="密码">
          <el-input v-model="pwd1" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitPwd1">保存</el-button>
        </el-form-item>
      </el-form>
      <!--    <span slot="footer" class="dialog-footer">-->
      <!--    <el-button @click="singlePriceDialog = false">取 消</el-button>-->
      <!--    <el-button type="primary" @click="singlePriceDialog = false">确 定</el-button>-->
      <!--  </span>-->
    </el-dialog>
  </div>
</template>
<script>
import Toolbar from "../../../../components/Toolbar.vue";
import {getButtonList} from "../../../../promissionRouter";
import {
  DistributionBatchPay,
  DistributionBatchPayInfo,
  DistributionPay,
  DistributionPayInfo,
  DistributionUnPaidOrderList, ExportDistributionUnPaidOrderList,
  GetAllReseller
} from "../../../../api/api";

export default {
  components: {Toolbar},
  data(){
    return {
      options: [{
        value: '10',
        label: '待支付'
      }, {
        value: '20',
        label: '备货中(待发货)'
      }, {
        value: '30',
        label: '待收货(已发货)'
      }, {
        value: '40',
        label: '已收货'
      }, {
        value: '50',
        label: '已完成'
      }, {
        value: '60',
        label: '已取消'
      }, {
        value: '70',
        label: '已关闭'
      }],
      pwd:'',
      pwd1:'',
      submitPayData:{},
      purchasePayData:{},
      purchasePayData1:{},
      input:'',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      currentRow: [],
      isBuyDialogShow:false,
      isBatchBuyDialogShow:false,
      pwdDialog:false,
      pwdDialog1:false,
      isBatchPayShow:false,
      isExportShow:false,
      isBuyShow:false,
      isOkPayShow:false,
      total:null,
      tableList:[],
      valueTime: [],
      supplierList: [],
      searchData: {
        ResellerId:null,
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName: null,
        DistributorUserName:'',
        ChannelBusiness:'',
        StartPayTime:null,
        EndPayTime:null,
        receivingName: null,
        Status: null,
      },
    }
  },
  mounted() {
    console.log(1)
    let routers = window.localStorage.router
        ? JSON.parse(window.localStorage.router)
        : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      console.log('buttonList', buttonList);
      this.buttonList_toolBar = toolBarButtonList;
      this.buttonList_toolBar && this.buttonList_toolBar.forEach((item) => {
        if (item.buttonFunc === 'batchPay'){
          this.isBatchPayShow = true;
        }
        if (item.buttonFunc === 'export2'){
          this.isExportShow = true;
        }
        if (item.buttonFunc === 'buyPay'){
          this.isBuyShow = true;
        }
        if (item.buttonFunc === "buyPay"){
          this.isOkPayShow = true;
        }
      })
      // const tableButtonList = buttonList.filter((item) => {
      //   return item.buttonShow === 20;
      // });
      // this.buttonList_table = tableButtonList;
    }
  },
  created(){
    this.getList()
    this.getDistributorList();
  },
  methods: {
    getOneData(){
      this.getList();
    },
    async getDistributorList() {
      let res = await GetAllReseller({PageIndex: 1, PageSize: 50});
      console.log('getDistributorList', res);
      if (res.data.success) {
        if (res.data.result.items.length > 0) {
          res.data.result.items.forEach((item) => {
            this.supplierList.push({id: item.id, name: item.name})
          })
          // if (this.supplierList.length > 0) {
          //   this.searchData.ResellerId = this.supplierList[0].id
          //   await this.getList()
          // }
        }
      } else {
        this.$message.error(res.data.error.message)
      }
    },
    closePwdDialog(){
      this.pwdDialog = false;
      this.pwd = '';
    },
    closePwdDialog1(){
      this.pwdDialog1 = false;
      this.pwd1 = '';
    },
    async submitPwd(){
      if (!this.pwd){
        return this.$message.error('请输入密码')
      }
      let data = {};
      data.password = this.pwd;
      data.childOrderId = this.purchasePayData.childOrderId;
      let res = await DistributionPay(data);
      console.log('支付结果', res);
      if (res.data.success){
        this.pwdDialog = false;
        this.pwd = '';
        this.isBuyDialogShow = false;
        this.purchasePayData = {};
       await this.getList();
      }else{
        this.$message.error(res.data.error.message)
      }
    },
    async submitPwd1(){
      if (!this.pwd1){
        return this.$message.error('请输入密码')
      }
      if (!this.purchasePayData1.childOrderIdList){
        return this.$message.error('缺少批量订单Id')
      }
      let data = {};
      data.password = this.pwd1;
      data.childOrderIdList = this.purchasePayData1.childOrderIdList;
      // console.log('data', data); return;
      let res = await DistributionBatchPay(data);
      console.log('支付结果', res);
      if (res.data.success){
        this.pwdDialog1 = false;
        this.pwd1 = '';
        this.isBatchBuyDialogShow = false;
        this.purchasePayData1 = {};
        await this.getList();
      }else{
        this.$message.error(res.data.error.message)
      }
    },
   async balancePay(){
     this.pwdDialog = true;
    },
    async balanceBatchPay(){
      this.pwdDialog1 = true;
    },
    closePurchaseDialog(){
      this.isBuyDialogShow = false;
      this.purchasePayData = {};
    },
    closeBatchPurchaseDialog(){
      this.isBatchBuyDialogShow = false;
      this.purchasePayData1 = {};
    },
    async getList() {
      let res = await DistributionUnPaidOrderList(this.searchData);
      console.log('res' ,res)
      if (res.data.success){
        if (res.data.result.data.data){
          this.tableList =  res.data.result.data.data;
          this.total = res.data.result.data.dataCount;
        }
      }else {
        this.$message.error(res.data.error.message)
      }
      console.log('res', res);
    },
   async batchPay() {
      if (!this.searchData.ResellerId){
        return this.$message.error('请选择供应商!')
      }
      if (this.currentRow.length <= 0 ) {
        return this.$message.error('请选择需要删除的数据!')
      }
      let childOrderIds = [];
      this.currentRow.forEach((row) => {
        childOrderIds.push(row.childOrderId);
      })
     let ids = childOrderIds.join(',')
      let res = await DistributionBatchPayInfo({childOrderIds:ids});
      console.log('resssss', res);
      if (res.data.success) {
        this.purchasePayData1 = res.data.result.data;
        this.isBatchBuyDialogShow = true;
      } else {
        return this.$message.error(res.data.result.message)
      }
    },
    async export2() {
      ExportDistributionUnPaidOrderList(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = '待付款.xlsx'  //后缀名一定要写对，不然会导致文件损坏，打不开
        a.href = objectUrl
        a.click()
        a.remove()
        console.log(res, '???????????')
      })
      // let res = await ExportDistributionUnPaidOrderList(this.searchData);
      // if (res.data.success) {
      //   this.$message.success('请前往下载中心查看！')
      // } else {
      //   this.$message.error(res.data.msg)
      // }
    },
    async buyPay(row) {
      let res = await DistributionPayInfo({childOrderId:row.childOrderId});
      console.log('resssss', res);
      if (res.data.success) {
        this.purchasePayData = res.data.result.data;
        this.isBuyDialogShow = true;
      } else {
        return this.$message.error(res.data.result.message)
      }


    },
    okPay() {},
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      // this.searchData.PageIndex = val;
      // this.getTableList();
    },
    handleSizeChange(e) {
      // this.searchData.PageSize = e;
      // this.getTableList();
    },
    searchFun(){
      this.searchData.PageIndex = 1;
      this.getList();
    },
    resetFun(){
      this.searchData = {
        PageIndex: 1, //页码
        PageSize: 10, //页长
        ChildOrderNo: null,
        SkuName: null,
        DistributorUserName: '',
        ChannelBusiness: '',
        StartPayTime:null,
        EndPayTime:null,
        receivingName: null,
        Status: null,
      };
      this.valueTime = [];
      this.getList();
    },
    handlePicker(e) {
      console.log('llllll', e)
      if (e == null) {
        this.valueTime = []
        this.searchData.CreationStartTime = null;
        this.searchData.CreationEndTime = null;
      } else {
        this.searchData.CreationStartTime = e[0];
        this.searchData.CreationEndTime = e[1];
      }
    },
  }
}
</script>



<style scoped>

</style>